import React, { useMemo } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { getThemeById } from '../../config/themes'
import type { TenantThemeConfig } from '../../types/theme'

interface AssetConfig {
  CDN_BASE_URL: string
  CSS_PATH: string
  IMG_PATH: string
  FONTS_PATH: string
}

export interface HistoryOutletContext {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
  getAssetUrl: (path: string) => string
}

interface ModernHistoryLayoutProps {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

const TABS = [
  { to: 'deposit', icon: '/img/deposit-icon.png', sub: 'ประวัติ', label: 'การฝากเงิน' },
  { to: 'withdraw', icon: '/img/withdraw-icon.png', sub: 'ประวัติ', label: 'การถอนเงิน' },
  { to: 'credit', icon: '/img/credit-icon.png', sub: 'ประวัติ', label: 'การรับเครดิต' },
  { to: 'gamble', icon: '/img/slot-icon.png', sub: 'ประวัติ', label: 'การเล่นพนัน' },
  { to: 'pending', icon: '/img/time-icon.png', sub: 'รอผล', label: 'การเล่นพนัน' },
  { to: 'btd', icon: '/img/sport-icon.png', sub: 'ประวัติ', label: 'เกมส์ BTD' },
]

/** Layout หน้า history: แท็บ 6 อัน (ฝาก, ถอน, เครดิต, เล่นพนัน, รอผล, BTD) + Outlet */
const ModernHistoryLayout: React.FC<ModernHistoryLayoutProps> = ({ themeConfig, assetConfig }) => {
  const themeFolder = useMemo(() => getThemeById(themeConfig.themeId)?.folder ?? 'HuayToday-Blue', [themeConfig.themeId])
  const getAssetUrl = (path: string) => {
    const base = assetConfig.CDN_BASE_URL ? `${assetConfig.CDN_BASE_URL}/${themeFolder}` : `/${themeFolder}`
    return base + (path.startsWith('/') ? path : `/${path}`)
  }
  const context: HistoryOutletContext = { themeConfig, assetConfig, getAssetUrl }

  return (
    <div className="content">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1">
            <div
              className="nav nav-pills nav-pills-htr mb-3"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              {TABS.map((tab) => (
                <NavLink
                  key={tab.to}
                  to={tab.to}
                  end={tab.to === 'deposit'}
                  className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                >
                  <div className="icon_cycle mx-auto mb-1">
                    <img src={getAssetUrl(tab.icon)} alt="" />
                  </div>
                  <div className="text-center">
                    <span>{tab.sub}</span>
                    <h6 className="font_md">{tab.label}</h6>
                  </div>
                </NavLink>
              ))}
            </div>
            <Outlet context={context} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModernHistoryLayout
